<template>
  <div class="u-analysis">
    <div class="cf-info" v-if="formDynamic.items.length">
      <div class="info-title">
        检视错误用药（{{ detailInfo.drugs.length }}个）
      </div>
      <Form ref="formDynamic" :model="formDynamic" label-position="top">
        <div
          class="info-item"
          v-for="(item, index) in formDynamic.items"
          :key="index"
        >
          <uAnalysisDetail
            :info="item"
            :index="index"
            :auditStage="auditStage"
            :isReplied="isReplied"
          />
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import uAnalysisDetail from "./uAnalysisDetail.vue";
export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    auditStage: {
      type: Number,
      default: 0,
    },
    isReplied: {
      //是否已回复
      type: Boolean,
      default: false,
    },
  },
  components: {
    uAnalysisDetail,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    detailInfo(newValue, oldValue) {
      this.setFormDynamic();
    },
  },
  data() {
    return {
      formDynamic: {
        items: [],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.formDynamic.validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: "提示",
            content: "确认回复吗?",
            onOk: () => {
              this.postData();
            },
          });
        } else {
          this.$Message.error("请将表单填写完整!");
        }
      });
    },
    handleReset() {
      this.$refs.formDynamic.resetFields();
    },
    setFormDynamic() {
      if (!this.detailInfo.drugs) return;
      this.formDynamic = {
        items: this.detailInfo.drugs,
      };
    },
    postData() {
      let obj = {
        records: this.formDynamic.items
          .filter((i) => i.auditStage == this.auditStage)
          .map((i) => {
            let item = i.records.find(
              (j) =>
                j.auditorType == this.auditStage &&
                j.auditorId == this.userInfo.husDoctorId
            );
            return {
              merId: item.merId,
              auditResult: i.auditResult, //结果 0 未回复 1 同意 2 拒绝
              auditReason: i.auditReason, //原因
            };
          }),
      };
      let url = this.auditStage == 1 ? "doctorAudit" : "committeeAudit";
      this.api2(url, obj).then((res) => {
        this.$Message.success("提交成功！");
        this.$emit("submitSuccess");
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.u-analysis {
  .more-btn {
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    opacity: 0.6;
  }

  :deep {
    .u-analysis-detail,
    .edit-body {
      padding: 15px 15px 20px;
      background-color: rgba(133, 58, 47, 0.05);
      border-radius: 5px;
      margin-bottom: 15px;
    }
    .footer {
      display: none;
    }
  }
}
</style>
